import { createSelector } from '@reduxjs/toolkit';
import { getCurrency } from '../context-selector.js';
export const getECPurchasePayload = (transaction, state) => ({
    currency: getCurrency(state.commerceContext),
    products: productQuantitySelector(state.cart),
    transaction,
});
export const getECCartActionPayload = (cartActionDetails, state) => ({
    currency: getCurrency(state.commerceContext),
    ...cartActionDetails,
});
export const itemsSelector = createSelector((cartState) => cartState.cart, (cartState) => cartState.cartItems, (cart, cartItems) => cartItems.map((key) => cart[key]));
const productQuantitySelector = createSelector(itemsSelector, (items) => items.map(({ quantity, ...product }) => ({
    quantity,
    product,
})));
